module.exports = __webpack_public_path__ + "static/teacher-f95e3bcceedcf09e4dceb13f2c2b0a12.svg";